import { type FC, useState } from 'react';

import { permissionLabel, permissionsOptions } from '../../../constants/data';
import {
  type AddEntityAclsData,
  aclsSetEditByType,
  addEntityAcls,
} from '../../../ducks/common_acls/thunks';
import { useAppDispatch } from '../../../store/react_redux_typed';
import Button from '../../../ui/button/button';
import SelectFieldWrapper from '../../../ui/forms/field_wrappers/select/select';
import Form from '../../../ui/forms/form';
import Label from '../../../ui/label/label';
import type { SelectOption } from '../../../ui/select_field/types';
import type { AclsContextItem } from '../types';

import styles from './permissions.module.css';

type FormData = {
  user_ids: string[];
  group_ids: string[];
  permissions?: SelectOption[];
};

type Props = {
  acl: AclsContextItem;
  edit?: boolean;
};

const Permissions: FC<Props> = (props) => {
  const { edit, acl } = props;

  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  if (!edit) {
    return (
      <div className={styles.permissions}>
        {acl.permissions.map((permission) => (
          <Label variant="info" key={permission} className={styles.permission}>
            {permissionLabel(permission)}
          </Label>
        ))}
      </div>
    );
  }

  return (
    <Form<FormData>
      onValidSubmit={(formData) => {
        if (!acl.aclsObjectId || !acl.aclsType) {
          return;
        }
        const permissions = (formData.permissions || []).map(
          (permission) => permission.value,
        );
        const data: AddEntityAclsData = {
          permissions,
          type: acl.type,
        };
        if ('user_id' in acl) {
          data.user_ids = [acl.user_id];
        }
        if ('group_id' in acl) {
          data.group_ids = [acl.group_id];
        }
        setLoading(true);
        dispatch(addEntityAcls(acl.aclsType, [acl.aclsObjectId], data))
          .then(() => {
            if (acl.aclsType) {
              dispatch(aclsSetEditByType(acl.aclsType, undefined));
            }
          })
          .finally(() => setLoading(false));
      }}
    >
      <SelectFieldWrapper
        disabled={loading}
        value={permissionsOptions.filter((value) =>
          acl.permissions.includes(value.value),
        )}
        options={permissionsOptions}
        name="permissions"
        aria={{ label: 'Permissions' }}
        isMulti
      />
      <div className={styles.buttons}>
        <Button
          uiKey="cancel"
          disabled={loading}
          variant="warning"
          className={styles.permissions_btn}
          onClick={() => {
            if (acl.aclsType) {
              dispatch(aclsSetEditByType(acl.aclsType, undefined));
            }
          }}
        >
          Cancel
        </Button>
        <Button
          uiKey="submit"
          disabled={loading}
          variant="success"
          type="submit"
          className={styles.permissions_btn}
        >
          Update
        </Button>
      </div>
    </Form>
  );
};

export default Permissions;
